import { render, staticRenderFns } from "./BImpersonated.vue?vue&type=template&id=4178db05&scoped=true"
import script from "./BImpersonated.vue?vue&type=script&setup=true&lang=ts"
export * from "./BImpersonated.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BImpersonated.vue?vue&type=style&index=0&id=4178db05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4178db05",
  null
  
)

export default component.exports